// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { ApplicationUser } from './ApplicationUser';

export class UserAccount extends ApplicationUser {
    _originalTypeClassName = "Loom.BO.UserAccount";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
UserAccount.translate = translateService;
}
super();
this.SavedViews = [];
this.Person = new Domain.Person();
this.Id = null;
this.AzureUpn = null;
this.AzureOID = null;
this.AuthorizedForBackofficeAccess = false;
this.ForcePasswordChange = false;
this.ShouldLogOut = false;
this.HasLocalPassword = false;
this.LastSeen = null;
this.LastSeenAt = null;
this._key = this.UserName = ""; 
}

static translate: TranslateService;
_key: any;
Id:any;
AzureUpn:any;
AzureOID:any;
AuthorizedForBackofficeAccess:any;
ForcePasswordChange:any;
ShouldLogOut:any;
HasLocalPassword:any;
LastSeen:any;
LastSeenAt:any;
SavedViews:any;
Person:any;
static setSavedViews = ($this, items) => {
                if (items == null) items = [];
                if ($this.SavedViews == null) $this.SavedViews = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SavedViews.length > 0) {
                    Domain.UserAccount.removeSavedViews($this, $this.SavedViews[0]);
                }

                Domain.UserAccount.addManySavedViews($this, copyItems);
            }
static addManySavedViews = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.UserAccount.addSavedViews($this, items[i]);
                }
            }
static addSavedViews = ($this, item) => {
                if ($this.SavedViews == null) $this.SavedViews = [];
                if (item == null || $this.SavedViews.indexOf(item) > -1) return;
                $this.SavedViews.push(item);
if (item.Owner != $this) {
Domain.SavedView.setOwner(item, $this);
}
}
static addRangeSavedViews = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.UserAccount.addSavedViews($this, item));
            }
static removeSavedViews = ($this, item) => {
                if ($this == null || $this.SavedViews == null || $this.SavedViews.indexOf(item) === -1) return;
                var _index = $this.SavedViews.indexOf(item);
                $this.SavedViews.splice(_index, 1);
item.Owner = null;
}
static clearSavedViews = ($this) => { $this.SavedViews = null; }
static setPerson = ($this, value) => {
var oldValue = $this.Person;
$this.Person = value;
if (value != null) {
if (oldValue != null && oldValue.Account != null) { oldValue.Account = null; }
if ($this.Person.Account !== $this) {
Domain.Person.setAccount(value, $this);
}
}
}

static GetClaim(jwt: any,claimType: any): any{return jwt.Claims?.linq?.where((c) => c.Type == claimType)?.firstOrDefault(null).Value;
}
static GetHasLocalPassword($this: any): any{return !(CLMS.Framework.String.IsNullOrEmpty(($this?.PasswordHash ?? '').trim()));
}
static PrintClaims(jwt: any): any{for (let _ic = 0; _ic < (jwt.Claims == null ? 0 : jwt.Claims.length); _ic++) {let c = jwt.Claims[_ic];console.debug("Claim: " + c.Type + ", Value: " + c.Value);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.UserName == null || $this.UserName == "";
            }


}